import axios from 'axios';

const AxiosLogin = axios.create({
    headers: {"X-Requested-With" : "XMLHttpRequest"}
});

export { AxiosLogin };


// WEBPACK FOOTER //
// ./axiosInstances/login.js